import { render, staticRenderFns } from "./WarehouseProducts.vue?vue&type=template&id=d23a233a&scoped=true"
import script from "./WarehouseProducts.vue?vue&type=script&lang=js"
export * from "./WarehouseProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23a233a",
  null
  
)

export default component.exports